<template>
  <div class="icon-component" :style="[{height: height + '!important'},{width: width + '!important'}]">
    <div v-if="getIconNames === getIconNames.toUpperCase()" class="icon" :class="{'icon-hover': cursorPointer}"
         :style="[{'-webkit-mask-image': 'url(' + imagePath(getIconNames, iconType)+')'},
               {'mask-image': 'url(' + imagePath(getIconNames, iconType)+')'},{width: width},
               {height: height},{backgroundColor: colorCode || colors[color] || colors.primary}]"></div>

    <font-awesome-icon v-else
                       :icon="[`fa${getIconWeight}`, getIconNames]"
                       :style="{
                         fontSize: width,
                         color: colorCode || colors[color] || colors.primary
                       }"/>
  </div>
</template>

<script>
export default {
  name: 'customIcon',
  props: {
    width: {
      type: String,
      default: '20px'
    },
    height: {
      type: String,
      default: '22px'
    },
    icon: {
      type: String,
      default: ''
    },
    iconType: {
      type: String,
      default: 'svg',
      validator (value) {
        return ['svg', 'png', 'jpg', 'jpeg', 'webp'].includes(value)
      }
    },
    iconWeight: {
      type: String,
      default: 'light',
      validator (value) {
        return ['light', 'regular', 'solid', 'duotone', 'kit'].includes(value)
      }
    },
    color: {
      type: String,
      default: () => {
        return 'primary'
      },
      validator (value) {
        if (value) {
          return ['success', 'danger', 'warning', 'gray', 'dark-gray', 'primary', 'white'].includes(value || 'success')
        } else {
          return true
        }
      }
    },
    colorCode: {
      type: String,
      default: () => {
        return ''
      }
    },
    cursorPointer: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      colors: {
        'primary': '#197ed5',
        'success': '#28c76f',
        'warning': '#ffa146',
        'danger': '#ea5455',
        'gray': '#cecece',
        'dark-gray': '#626262',
        'white': '#ffffff'
      }
    }
  },
  computed: {
    getIconNames () {
      switch (this.icon) {
      case 'plus-icon':
        return 'plus-large'

      case 'edit-icon':
        return 'pen-line'

      case 'save-icon':
        return 'floppy-disk'

      case 'print-icon':
        return 'print'

      case 'list-icon':
        return 'list-check'

      case 'setting-icon':
        return 'gear'

      case 'trash-icon':
        return 'trash-can'

      case 'bin-recycle-icon':
        return 'trash-can'

      default:
        return this.icon.replace('-icon', '')
      }
    },
    getIconWeight () {
      switch (this.getIconNames) {
      case 'solid-cart-shopping-rotate':
      case 'regular-cart-shopping-rotate':
      case 'solid-bag-shopping-rotate':
      case 'regular-bag-shopping-rotate':
      case 'regular-bag-shopping-location-pin':
      case 'regular-bag-shopping-globe':
      case 'regular-bag-shopping-circle-ellipsis':
      case 'regular-cart-shopping-location-pin':
      case 'regular-cart-shopping-globe':
      case 'regular-cart-shopping-circle-ellipsis':
      case 'regular-arrow-up-right-dots-circle-plus':
      case 'regular-arrow-up-right-dots-location-pin':
      case 'regular-arrow-up-right-dots-globe':
        return 'k'

      default:
        switch (this.iconWeight) {
        case 'light':
        case 'solid':
        case 'regular':
        case 'duotone':
        case 'kit':
          return this.iconWeight[0]
        }
      }
    }
  },
  methods: {
    imagePath (name, type) {
      return require(`@/assets/icons/${  name  }.${  type}`)
    }
  }
}
</script>

<style lang="scss" scoped>

div.icon-component {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    display: inline-block;
    background-size: cover;
    mask-position: center !important;
    -webkit-mask-position: center !important;
    mask-repeat: no-repeat !important;
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;

    &.icon-hover {

      &:hover, &:focus {
        cursor: pointer;
        filter: invert(27%) sepia(5%) hue-rotate(10deg) brightness(100%) contrast(90%);
      }
    }
  }
}

@supports (-webkit-touch-callout: none) {
  /* CSS specific to iOS devices */
  @media print {
    .icon-component {
      .icon {
        background-color: unset !important;
      }
    }
  }
}

</style>
